const moment = require("moment-timezone");

const dateFormat = "YYYY-MM-DD";
const datetimeFormat = "YYYY-MM-DD HH:mm:ss";

const toDateString = (t) => moment(t).format(dateFormat);
const toDateStringLastMonth = (t) => moment(t).add(-1, 'M').format(dateFormat);
const toDatetimeString = (t) => moment(t).format(datetimeFormat);


const dateHelper = (date, type='datetime') => {
    try{
        if(date){
            if(type === 'date') return toDateString(date);
            if(type === 'datetime') return toDatetimeString(date);
            if(type === 'lastM') return toDateStringLastMonth(date);
        }
    } catch (error) {
        console.error(error);
    }
    return date;
    
}

const textHelper = (t, zeroReturn=false) => {
    let text = t + "";
    try{
        if(text){
            text = text.trim();
            if (['', 'null', 'undefined'].includes(text)){
                if(zeroReturn) return "0";
                return "";
            } 
            return text;
        } else if (zeroReturn) {
            return "0";
        } 
    } catch (error) {
        console.error(error);
    }
    return "";
}


const switchHelper = (value) => {
    /**
     * For boolean (TintInt), convert checkbox default `checked` value to 1 and 0
     */
    if ([true, 'on', 1, 'checked'].includes(value))
        return 1;
    else return 0;
}

const dictFinder = (dictObj, searchKey, searchValue) => {
    try{
        for(let i = 0; i < dictObj.length; i++){
            for(let j in dictObj[i]){
                if (j === searchKey){
                    if((dictObj[i][j] + "")===(searchValue + "")){
                        return dictObj[i];
                    }
                }
            }
        }
        
    } catch (error) {
        console.error(error);
    }
    return {};
    
}

const getQuarterRange = (quarter) => {
    const start = moment().quarter(quarter).startOf('quarter').format('YYYY-MM-DD');
    const end = moment().quarter(quarter).endOf('quarter').format('YYYY-MM-DD');
    return {start, end};
}

const getDateRange = (firstDate, lastDate) => {
    if (moment(firstDate, 'YYYY-MM-DD').isSame(moment(lastDate, 'YYYY-MM-DD'), 'day'))
        return [lastDate];
    let date = firstDate;
    const dates = [date];
    do {
        date = moment(date).add(1, 'day');
        dates.push(date.format('YYYY-MM-DD'));
    } while (moment(date).isBefore(lastDate));
    return dates;
};

const dateListCreator = (type) => {
    const startOfThisMonth = moment().startOf('month').format('YYYY-MM-DD');
    const endOfThisMonth   = moment().endOf('month').format('YYYY-MM-DD');
    const startOfThisYear = moment().startOf('year').format('YYYY-MM-DD');
    const endOfThisYear   = moment().endOf('year').format('YYYY-MM-DD');
    const thisQuarter = moment().quarter();
    const thisQuarterRange = getQuarterRange(thisQuarter);
    if(type==="7d"){
        return getDateRange(moment(Date.now()).add(-6, 'd').format('YYYY-MM-DD'), moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="14d"){
        return getDateRange(moment(Date.now()).add(-13, 'd').format('YYYY-MM-DD'), moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="30d"){
        return getDateRange(moment(Date.now()).add(-29, 'd').format('YYYY-MM-DD'), moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="1M"){
        return getDateRange(moment(Date.now()).add(-1, 'M').format('YYYY-MM-DD'), moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="3M"){
        return getDateRange(moment(Date.now()).add(-3, 'M').format('YYYY-MM-DD'), moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="6M"){
        return getDateRange(moment(Date.now()).add(-6, 'M').format('YYYY-MM-DD'), moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="1y"){
        return getDateRange(moment(Date.now()).add(-1, 'y').format('YYYY-MM-DD'), moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="thisM"){
        return getDateRange(startOfThisMonth, endOfThisMonth);
    } else if(type==="thisMN"){
        return getDateRange(startOfThisMonth, moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="thisQ"){
        return getDateRange(thisQuarterRange.start, thisQuarterRange.end);
    } else if(type==="thisQN"){
        return getDateRange(thisQuarterRange.start, moment(Date.now()).format('YYYY-MM-DD'));
    } else if(type==="thisY"){
        return getDateRange(startOfThisYear, endOfThisYear);
    } else if(type==="thisYN"){
        return getDateRange(startOfThisYear, moment(Date.now()).format('YYYY-MM-DD'));
    }
    return [];
}

module.exports = {
    switchHelper,
    dateHelper,
    textHelper,
    dictFinder,
    dateListCreator,
}